import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { IPlatformUser } from "@nova/common-interfaces";

@Component({
  selector: "app-authenticated-header",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./authenticated-header.component.html",
  styleUrl: "./authenticated-header.component.scss",
})
export class AuthenticatedHeaderComponent {
  @Output() toggle = new EventEmitter<boolean>();
  pageTitle: string = "";
  userAvatar: string = "/assets/default-avatar.png";
  isOn = false;

  @Input()
  user: IPlatformUser | undefined;

  constructor(private router: Router, private route: ActivatedRoute) {}

  toggleState() {
    this.isOn = !this.isOn;
    this.toggle.emit(this.isOn);
  }
  
  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updatePageTitle();
      }
    });
  }

  updatePageTitle(): void {
    const routeData = this.route.snapshot.firstChild?.data;
    this.pageTitle = routeData?.["title"] || "";
  }
}
